import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem("fp_admin_token");
  const custToken = localStorage.getItem("fp_customer_token");
  if (config.url?.includes("/admin") || config.url?.includes("/auth/admin")) {
    if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
  } else if (custToken) {
    config.headers.Authorization = `Bearer ${custToken}`;
  }
  return config;
});

export default api;

// ---- public ----
export const getConfig = () => api.get("/config").then((r) => r.data);
export const getCategories = () => api.get("/categories").then((r) => r.data);
export const getCategory = (slug) => api.get(`/categories/${slug}`).then((r) => r.data);
export const getProducts = (params) => api.get("/products", { params }).then((r) => r.data);
export const getProductsByIds = (ids) => api.get("/products/batch", { params: { ids: (ids || []).join(",") } }).then((r) => r.data);
export const validateCoupon = (code, subtotal) => api.post("/coupons/validate", { code, subtotal }).then((r) => r.data);
export const getShippingQuote = (payload) => api.post("/shipping/quote", payload).then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const getPages = () => api.get("/pages").then((r) => r.data);
export const getPage = (slug) => api.get(`/pages/${slug}`).then((r) => r.data);
export const getHome = () => api.get("/pages/home").then((r) => r.data);
export const getLandings = () => api.get("/landings").then((r) => r.data);
export const getLanding = (slug) => api.get(`/landings/${slug}`).then((r) => r.data);
export const checkout = (payload) => api.post("/orders/checkout", payload).then((r) => r.data);
export const paymentStatus = (number) => api.get(`/payments/status/${number}`).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const orderPdfUrl = (id) => `${API}/orders/${id}/pdf`;

// ---- customer ----
export const custRegister = (p) => api.post("/auth/customer/register", p).then((r) => r.data);
export const custLogin = (p) => api.post("/auth/customer/login", p).then((r) => r.data);
export const custMe = () => api.get("/auth/customer/me").then((r) => r.data);
export const custForgotPassword = (email) => api.post("/auth/customer/forgot-password", { email }).then((r) => r.data);
export const custResetInfo = (token) => api.get(`/auth/customer/reset-info/${token}`).then((r) => r.data);
export const custResetPassword = (token, password) => api.post("/auth/customer/reset-password", { token, password }).then((r) => r.data);
export const custOrders = () => api.get("/customer/orders").then((r) => r.data);
export const custInvoices = () => api.get("/customer/invoices").then((r) => r.data);
export const payOrderRedsys = (orderId) => api.post(`/orders/${orderId}/pay-redsys`).then((r) => r.data);
export const payByLink = (orderId) => api.post(`/orders/${orderId}/pay-link`).then((r) => r.data);

// ---- admin ----
export const adminLogin = (p) => api.post("/auth/admin/login", p).then((r) => r.data);
export const adminMe = () => api.get("/auth/admin/me").then((r) => r.data);
export const adminApi = api;

export const downloadBlob = async (path, filename) => {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await api.post("/admin/upload", fd);
  return res.data.url;
};
